<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <v-skeleton-loader
        class="skeleton-wrapper sprint-text"
        type="text"
        :loading="isLoading"
        v-if="isLoading"
      ></v-skeleton-loader>
      <h1 class="task-title" v-else>
        Evolução Individual <v-icon>mdi-chart-line</v-icon>
      </h1>
    </div>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-row>
      <v-col cols="6">
        <v-card flat color="transparent">
          <div class="flex">
            <v-card-title class="task-card-title">
              Acompanhe a evolução de cada membro do projeto:
            </v-card-title>
            <v-select
              :no-data-text="'Ainda não há dados de usuários a serem exibidos.'"
              v-model="membroSelecionado"
              :items="
                this.usuarioMedias.map((membro) => ({
                  title: membro.nome,
                  media: membro.avaliacoes,
                }))
              "
              variant="underlined"
              hint="Selecione um
            membro"
              persistent-hint="Selecione um membro"
              return-object
            ></v-select>
            <!-- <p>
              Valores selecionados: {{ membroSelecionado }}, tipo:
              {{ typeof membroSelecionado }}
            </p> -->
          </div>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="!isLoading">
      <line-chart
        class="line-chart"
        :titulo="tituloGrafico"
        :media="mediaGrafico"
        :key="membroSelecionado"
      ></line-chart>
    </div>
    <p style="color: #444444; font-size: 14px">
      *Caso não exista linha traçada em algum dos pontos, significa dizer que a
      avaliação ainda não foi respondida.
    </p>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import LineChart from '@/components/LineChart.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    VSkeletonLoader,
    LineChart,
  },
  data() {
    return {
      idProjeto: null,
      tituloGrafico: undefined,
      mediaGrafico: undefined,
      isLoading: true,
      usuarioMedias: [],
      membroSelecionado: null,
    };
  },
  watch: {
    membroSelecionado() {
      this.tituloGrafico = this.membroSelecionado.media.map(
        (item) => item.tituloAvaliacao,
      );
      this.mediaGrafico = this.membroSelecionado.media.map(
        (item) => item.media,
      );
    },
  },
  created() {
    this.fetchEvolucao(this.$route.params.id);
    // Mock de testes para funcionalidade
    // this.mock();
  },
  methods: {
    fetchEvolucao(idProjeto) {
      axios
        .get(API_URL + `/avaliacoes/consultarEvolucaoIndividual/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.usuarioMedias = response.data.usuarioMedias;

          // Fazendo o parse para a melhor forma
          const resultado = [];
          const usuarios = {};

          this.usuarioMedias.forEach((item) => {
            const { nome, media, tituloAvaliacao, dtfimAvaliacao } = item;

            if (!usuarios[nome]) {
              usuarios[nome] = [];
            }

            usuarios[nome].push({
              media,
              tituloAvaliacao,
              dtfimAvaliacao,
            });
          });

          for (const nome in usuarios) {
            resultado.push({
              nome,
              avaliacoes: usuarios[nome],
            });
          }

          this.usuarioMedias = resultado;
          console.log(this.usuarioMedias);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);

          this.isLoading = false;
        });
    },
    mock() {
      const usuarioMedias = [
        {
          nome: 'Larissa Vitoria',
          media: 8.28125,
          tituloAvaliacao: 'avaliação qualitativa',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Natalo Santos',
          media: 8.21875,
          tituloAvaliacao: 'avaliação qualitativa',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Leticia Silveira',
          media: 8.25,
          tituloAvaliacao: 'avaliação qualitativa',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Larissa Vitoria',
          media: 9.75,
          tituloAvaliacao: 'avaliação qualitativa 2',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Natalo Santos',
          media: 9,
          tituloAvaliacao: 'avaliação qualitativa 2',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Leticia Silveira',
          media: 8.75,
          tituloAvaliacao: 'avaliação qualitativa 2',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Leticia Silveira',
          media: 5.75,
          tituloAvaliacao: 'Avaliação qualitativa 3',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Natalo Santos',
          media: 10,
          tituloAvaliacao: 'Avaliação qualitativa 9',
          dtfimAvaliacao: '2023-09-09T16:45:44.000Z',
        },
        {
          nome: 'Larissa Vitoria',
          media: 4.75,
          tituloAvaliacao: 'Avaliação',
          dtfimAvaliacao: '2023-09-10T16:45:44.000Z',
        },
      ];

      const resultado = [];
      const usuarios = {};

      usuarioMedias.forEach((item) => {
        const { nome, media, tituloAvaliacao, dtfimAvaliacao } = item;

        if (!usuarios[nome]) {
          usuarios[nome] = [];
        }

        usuarios[nome].push({
          media,
          tituloAvaliacao,
          dtfimAvaliacao,
        });
      });

      for (const nome in usuarios) {
        resultado.push({
          nome,
          avaliacoes: usuarios[nome],
        });
      }

      this.usuarioMedias = resultado;
      console.log(this.usuarioMedias);
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.task-title {
  font-size: 22px;
  font-weight: bold;
}
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.sprint-text {
  font-size: 22px;
  font-weight: bold;
}
.line-chart {
  height: 68vh;
}
.task-card-title {
  font-size: 16px;
  margin-bottom: 10px;
}
.flex {
  display: flex;
}
</style>
